import { capitalize } from "lodash-es";

export const toSnakeCaseWithParenthesis = (title: string): string => {
  return title.replace(/_/g, " ").replace(/\w+/g, capitalize);
};
